<template>
  <div>
    <input
      class="modal-state"
      id="builder-require-auth-modal"
      type="checkbox"
      @input="$emit('input', !!$event.target.checked)"
      :checked="value"
    />
    <div class="modal">
      <label
        class="modal__bg"
        for="builder-require-auth-modal"
      ></label>
      <div class="modal__inner">
        <label
          class="modal__close"
          for="builder-require-auth-modal"
        ></label>
        <div
          class="h-full w-full flex flex-col items-center justify-between"
        >
          <div class="mt-2 text-lg text-gray-900 font-bold">
            Choose a payment method
          </div>

          <div class="w-full">
            <button
              @click="doBuyWithStripe()"
              type="button"
              class="btn-purple text-white w-full"
              :disabled="loadingCheckout"
            >
              <i class="fas fa-credit-card mr-1" />
              Credit Card
            </button>

            <button
              @click="doBuyWithPaypalUsd()"
              type="button"
              class="btn-blue w-full mt-3"
              :disabled="loadingCheckout"
            >
              <i class="fab fa-paypal mr-1" /> PayPal
            </button>
          </div>

          <el-link
            class="text-xs mb-1"
            @click="doBuyWithPaypalBrl()"
            :disabled="loadingCheckout"
          >
            Caso você seja
            <span class="text-green-500">brasileiro</span>,
            clique aqui para pagar em reais. O
            <span class="text-blue-500">PayPal</span>
            não aceita pagamento em dólares por brasileiros.
          </el-link>
        </div>
      </div>
    </div>

    <form
      ref="paypalUsdFormRef"
      :action="paypalFormAction"
      method="post"
      target="_top"
      class="hidden"
    >
      <input type="hidden" name="cmd" value="_s-xclick" />
      <input
        type="hidden"
        name="hosted_button_id"
        :value="paypalCodeUsd"
      />
      <input
        type="hidden"
        name="invoice"
        :value="paypalInvoice"
      />
    </form>

    <form
      ref="paypalBrlFormRef"
      :action="paypalFormAction"
      method="post"
      target="_top"
      class="hidden"
    >
      <input type="hidden" name="cmd" value="_s-xclick" />
      <input
        type="hidden"
        name="hosted_button_id"
        :value="paypalCodeBrl"
      />
      <input
        type="hidden"
        name="invoice"
        :value="paypalInvoice"
      />
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { v4 as uuid } from 'uuid';
import affiliates from '../util/affiliates';
import config from '../config';
import * as Sentry from '@sentry/browser';

export default {
  name: 'app-pricing-modal',
  props: ['value'],
  data() {
    return {
      loadingCheckout: false,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser',
    }),

    paypalInvoice() {
      if (!this.currentUser) {
        return null;
      }

      return `premium.${
        this.currentUser.uid
      }.${uuid()}.${affiliates.get()}`;
    },

    paypalFormAction() {
      return `${config.PAYPAL_URL}/cgi-bin/webscr`;
    },

    paypalCodeBrl() {
      return config.PAYPAL_CODES.BRL;
    },

    paypalCodeUsd() {
      return config.PAYPAL_CODES.USD;
    },
  },
  methods: {
    async doBuyWithStripe() {
      if (this.loadingCheckout) {
        return;
      }

      try {
        this.loadingCheckout = true;

        const result = await window
          .Stripe(config.STRIPE_TOKEN)
          .redirectToCheckout({
            items: [
              { sku: config.STRIPE_SKU, quantity: 1 },
            ],
            successUrl: `${config.CLIENT_APP_URL}/purchase/success`,
            cancelUrl: `${config.CLIENT_APP_URL}/purchase/cancel`,
            customerEmail: this.currentUser.email,
            clientReferenceId: `${
              this.currentUser.uid
            }.${affiliates.get()}`,
          });

        this.loadingCheckout = false;

        if (result.error) {
          alert(result.error.message);
        }
      } catch (error) {
        Sentry.captureException(error);
        this.loadingCheckout = false;
      }
    },

    async doBuyWithPaypalUsd() {
      if (this.loadingCheckout) {
        return;
      }

      this.loadingCheckout = true;
      this.$refs.paypalUsdFormRef.submit();
    },

    async doBuyWithPaypalBrl() {
      if (this.loadingCheckout) {
        return;
      }

      this.loadingCheckout = true;
      this.$refs.paypalBrlFormRef.submit();
    },
  },
};
</script>

<style scoped>
.modal {
  opacity: 0;
  visibility: hidden;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  text-align: left;
  background: rgba(0, 0, 0, 0.9);
  z-index: 2;
  transition: opacity 0.25s ease;
}

.modal__bg {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  cursor: pointer;
}

.modal-state {
  display: none;
}

.modal-state:checked + .modal {
  opacity: 1;
  visibility: visible;
}

.modal-state:checked + .modal .modal__inner {
  top: 0;
}

.modal__inner {
  transition: top 0.25s ease;
  position: absolute;
  top: -20%;
  right: 0;
  bottom: 0;
  left: 0;
  width: 40%;
  margin: auto;
  overflow: auto;
  background: #fff;
  border-radius: 5px;
  padding: 1em 2em;
  height: 240px;
}

.modal__close {
  position: absolute;
  right: 1em;
  top: 1em;
  width: 1.1em;
  height: 1.1em;
  cursor: pointer;
}

.modal__close:after,
.modal__close:before {
  content: '';
  position: absolute;
  width: 2px;
  height: 1.5em;
  background: #ccc;
  display: block;
  transform: rotate(45deg);
  left: 50%;
  margin: -3px 0 0 -1px;
  top: 0;
}

.modal__close:hover:after,
.modal__close:hover:before {
  background: #aaa;
}

.modal__close:before {
  transform: rotate(-45deg);
}

@media screen and (max-width: 992px) {
  .modal__inner {
    width: 50%;
    height: 240px;
    box-sizing: border-box;
  }
}

@media screen and (max-width: 768px) {
  .modal__inner {
    width: 90%;
    height: 240px;
    box-sizing: border-box;
  }
}
</style>
